module.exports = __webpack_public_path__ + "media/images/writing-c582e6decd8731443deacf2e57017d39.svg";